import * as React from 'react'

import { inject, observer } from 'mobx-react'

import EquipmentEditPanel from '~/client/src/desktop/components/EquipmentResource/EquipmentEditPanel'
import {
  IResourceControlsConfig,
  ResourceControlsView,
  RESOURCE_CONTROL_KEYS,
} from '~/client/src/desktop/components/ResourceControls'
import DesktopInitialState from '~/client/src/desktop/stores/DesktopInitialState'
import { EquipmentProvider } from '~/client/src/desktop/views/Equipment/EquipmentProvider'
import { LocalStorageKey } from '~/client/src/shared/enums/LocalStorageKey'
import { useEquipmentResourceStore } from '~/client/src/shared/hooks/useEquipmentResourceStore'
import Localization from '~/client/src/shared/localization/LocalizationManager'

function EquipmentControls({ state }: { state?: DesktopInitialState }) {
  const projectId = state?.activeProject?.id || ''
  const userId = state?.user?.id || ''
  const { store } = useEquipmentResourceStore(projectId || undefined)

  if (!projectId || !userId || !state) {
    return null
  }

  const config: IResourceControlsConfig = {
    ProviderComponent: EquipmentProvider,
    controlCommands: store.controls,
    columnConfigKey: LocalStorageKey.EquipmentControlsColumnConfig,
    editPanel: <EquipmentEditPanel defaultExpandedSectionId="controls" />,
    labels: {
      countTotal: Localization.translator.xEquipment,
      confirmDelete: Localization.translator.confirmDeletionOfEquipment,
    },
    ariaLabel: 'Equipment controls table',
    controls: RESOURCE_CONTROL_KEYS,
  }

  return (
    <ResourceControlsView
      config={config}
      projectId={projectId}
      userId={userId}
      state={state}
    />
  )
}

export default inject('state')(observer(EquipmentControls))
